import React, { useState } from "react";
import { Box } from "@mui/material";
import BottomNavigation from "./bottomNavigator/MenuBar";
import { useSelector } from "react-redux";
import LoadingModal from "../components/loading";

const MainLayout = ({ children }) => {
  const selector = useSelector((st) => st?.global?.route);
  const [active, setActive] = useState(selector);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      height="100%"
      width={"100%"}
      maxWidth={"800px"}
      bgcolor="background.paper"
      justifyContent={"space-between"}
      sx={{
        mx: "auto",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
        boxShadow: { xs: "none", sm: "0px 0px 40px 0px rgba(17,17,17,0.08)" },
      }}
    >
      <LoadingModal />
      <Box
        id="main-scroll"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        width={"100%"}
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          overscrollBehaviorY: "none",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {children}
      </Box>
      <BottomNavigation active={active} setActive={setActive} />
    </Box>
  );
};

export default MainLayout;
